<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :showSearchbox="showSearchbox"
    :showGroupActions="showGroupActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getCloudEnvTableColumn } from '@/utils/common/tableColumn'
import { getBrandFilter, getAccountFilter } from '@/utils/common/tableFilter'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'

export default {
  name: 'BillshieldList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        apiVersion: 'v1',
        resource: 'shield_bills',
        getParams: this.getParam,
        filterOptions: {
          id: {
            label: this.$t('table.title.id'),
            filter: true,
            formatter: val => {
              return `id.equals('${val}')`
            },
          },
          name: {
            label: this.$t('table.title.name'),
            filter: true,
            formatter: val => {
              return `name.contains('${val}')`
            },
          },
          brand: getBrandFilter(),
          account: getAccountFilter({ distinctType: 'field' }),
        },
      }),
      groupActions: [
        {
          label: this.$t('bill.text_193'),
          permission: 'shieldbills_create',
          action: () => {
            this.$router.push({
              path: '/bill-config/create',
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
      ],
      exportDataOptions: {
        downloadType: 'local',
        items: [
          { key: 'name', label: this.$t('table.title.name') },
          getCloudEnvTableColumn(),
          { key: 'brand', label: this.$t('table.title.brand') },
          { key: 'account', label: this.$t('common.account') },
          {
            key: 'product',
            label: this.$t('bill.shield_res_type'),
            formatter: ({ row }) => {
              let list = []
              if (row.product) {
                list = JSON.parse(row.product)
              }
              const ret = list.map(item => {
                return item.product_name
              })
              return ret.join(',')
            },
          },
        ],
      },
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    getParam () {
      const getParams = (R.is(Function, this.getParams) ? this.getParams() : this.getParams)
      const ret = {
        details: true,
        ...getParams,
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillshieldSidePage', {
        id: row.id,
        resource: () => {
          return {
            data: row,
          }
        },
      }, {
        list: this.list,
        hiddenActions: this.hiddenActions,
      })
    },
  },
}
</script>
